import React, {Component} from 'react';

function withDummySidebars(WrappedPageComponent) {
    return class extends Component {
        constructor(props) {
            super(props)
        }

        render() {
            return (
                <React.Fragment>
                    <div className="container">
                        <div className="row">
                            <section className="left-col">
                                <div className="left-col-container">
                                </div>
                            </section>
                            <WrappedPageComponent {...this.props}/>
                            <section className="right-col">
                                <div className="right-col-container sidebar__inner">
                                </div>
                            </section>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default withDummySidebars;